/**
 * Fee grace days of a group: how many days a member can keep booking with
 * the rates of the group, or of its parent group, while a fee is unpaid.
 * The backend accepts a whole number from 0 to MAX_FEE_GRACE_DAYS, or null
 * to stop blocking.
 */
export const MAX_FEE_GRACE_DAYS = 365;

/**
 * Keep only the digits typed in the field, as the price fields do, so the
 * value on screen is always the value that will be sent.
 */
export const sanitizeFeeGraceDays = (value: unknown): string =>
    String(value ?? '').replace(/\D/g, '');

/**
 * Parse the fee grace days of a group form for the API: null when the field
 * is empty (the group stops blocking), the number when it is a whole number
 * within range, and undefined when it is not valid, so the form warns instead
 * of clearing the value.
 */
export const parseFeeGraceDays = (
    value: string | number | null | undefined,
): number | null | undefined => {
    const text = String(value ?? '').trim();

    if (text === '') {
        return null;
    }

    if (!/^\d+$/.test(text)) {
        return undefined;
    }

    const days = Number(text);

    return days <= MAX_FEE_GRACE_DAYS ? days : undefined;
};
